import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { reportError } from '../utils/reportApiError';
import {
  fetchWithRetry,
  isTransportError,
  isLoadBalancerStatus,
  transportErrorMessage,
  ERRORE_GENERICO,
  SERVIZIO_IN_AGGIORNAMENTO,
} from '../utils/api/api';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    textAlign: 'center',
    padding: theme.spacing(4),
  },
}));

const ConfermaRegistrazione = ({ activationKey }) => {
  const classes = useStyles();

  const ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT;
  const url = ENDPOINT + `/api/account/conferma_registrazione/${activationKey}`;

  useEffect(() => {
    let isMounted = true;
    let debounceTimer;

    const fetchConfirmation = () => {
      fetchWithRetry(url, {
        method: 'GET',
      })
        .then((response) => {
          if (response.status === 200) {
            return response.text();
          }
          // The status alone: the catch below turns it into a sentence, where
          // `HTTP error 503` used to put protocol text in front of the operator.
          throw new Error(response.status.toString());
        })
        .catch((error) => {
          if (isMounted) {
            if (error.message === '404') {
              reportError('Registrazione già confermata.', 'Attenzione');
            } else if (isTransportError(error)) {
              reportError(transportErrorMessage(), 'Errore');
            } else if (isLoadBalancerStatus(Number(error.message))) {
              reportError(SERVIZIO_IN_AGGIORNAMENTO, 'Errore');
            } else {
              reportError(ERRORE_GENERICO, 'Errore');
            }
          }
        });
    };

    debounceTimer = setTimeout(fetchConfirmation, 300);

    return () => {
      isMounted = false;
      clearTimeout(debounceTimer);
    };
  }, [url]);

  return (
    <div className={classes.mainContainer}>
      <Typography variant="h4">
        Registrazione confermata con successo.
      </Typography>
    </div>
  );
};

ConfermaRegistrazione.propTypes = {
  activationKey: PropTypes.string.isRequired,
};

export default ConfermaRegistrazione;
